import loginSagas from '../routes/login/modules/login-sagas';
import userSagas from './user-sagas';
import gamesMainSagas from '../routes/app/routes/games/routes/main/modules/games-main-sagas';
import gameNewSagas from '../routes/app/routes/games/routes/new/modules/game-new-sagas';
import gameEditSagas from '../routes/app/routes/games/routes/edit/modules/game-edit-sagas';

import flowSagas from './flow-sagas';

export default function* RootSaga() {
    yield [
        loginSagas(),
        userSagas(),
        flowSagas(),
        gamesMainSagas(),
        gameEditSagas(),
        gameNewSagas()
    ];
}



// WEBPACK FOOTER //
// ./src/js/sagas/index.js